import { render, staticRenderFns } from "./TextAreaDefault.vue?vue&type=template&id=d37e188c&scoped=true&"
import script from "./TextAreaDefault.vue?vue&type=script&lang=js&"
export * from "./TextAreaDefault.vue?vue&type=script&lang=js&"
import style0 from "./TextAreaDefault.vue?vue&type=style&index=0&id=d37e188c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37e188c",
  null
  
)

component.options.__file = "TextAreaDefault.vue"
export default component.exports